export default {
  unitLabel: {
    potential: 'Potencjał C/N',
    nitridingToCarbon: 'kN/kC',
    content: 'Zawartość C/N',
    depth: 'Głębokość',
    hardness: 'Twardość',
    carbDepth: 'Głębokość nawęglania',
  },
  profile: {
    carbonProfile: 'Profil węglowy',
    nitrogenProfile: 'Profil azotowy',
    carbideProfile: 'Profil węglikowy',
  },
  legendLabel: 'Legenda',
};
